import { EngineReportFilter } from '@navstation-portal/reporting/data-model/engine-reports';

const toDateStamp = (date: Date): string => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

/**
 * Matches V1's extract filename format (`{vesselName} - {reportFilter} -
 * {YYYY-MM-DD}.csv`, see `engineReports.controller.ts#extractData`), but
 * always includes the vessel name since this page only ever extracts for a
 * single vessel (the V1 multi-vessel branch is not applicable here).
 */
export const buildExtractFilename = (
  vesselName: string,
  reportFilter: EngineReportFilter,
  now: Date = new Date()
): string => `${vesselName} - ${reportFilter} - ${toDateStamp(now)}.csv`;
